module.exports = __webpack_public_path__ + "static/media/channel.d2caa4fb.svg";